module.exports = __webpack_public_path__ + "img/logoDomotec.9f4de74e.png";